// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// TRACE FILE SCHEMA
/////////////////////////////////////////

export const TraceFileSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  traceId: z.string(),
  threadId: z.string(),
  name: z.string(),
  size: z.number().int(),
  content: z.string(),
  createdAt: z.coerce.date(),
})

export type TraceFile = z.infer<typeof TraceFileSchema>

export default TraceFileSchema;
